import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
	getFieldOfficerListFailure,
	getFieldOfficerListResponseChanged,
	getFieldOfficerListSuccess,
	getFieldOfficerLocationFailure,
	getFieldOfficerLocationResponseChanged,
	getFieldOfficerLocationSuccess,
} from './officer-location-report.action';
import {
	getFieldOfficerListAPI,
	getFieldOfficerLocationAPI,
} from './officer-location-report.services';
import OfficerLocationActionType from './officer-location-report.types';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/*********  START GET FIELD OFFICER LIST  *********/
export function* getFieldOfficerListDetails({ payload }: any) {
	try {
		const key = 'GetFieldOfficerListKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			BranchID: payload.BranchID,
			LocationID: payload.centerID,
			InputDate: payload.inputDate,
		};
		const checkinLocationData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getFieldOfficerListAPI, checkinLocationData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getFieldOfficerListFailure(responseData.data));
		} else {
			yield put(getFieldOfficerListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getFieldOfficerListFailure(error));
	}
}

export function* getFieldOfficerListDetailsResponseClear() {
	yield put(getFieldOfficerListResponseChanged());
}

export function* onGetFieldOfficerListStart() {
	yield takeLatest(
		OfficerLocationActionType.GET_FIELD_OFFICER_LIST_START,
		getFieldOfficerListDetails,
	);
}

export function* onGetFieldOfficerListResponseRest() {
	yield takeLatest(
		OfficerLocationActionType.GET_FIELD_OFFICER_LIST_RESPONSE_RESET,
		getFieldOfficerListDetailsResponseClear,
	);
}
/*********  END GET FIELD OFFICER LIST  *********/

/*********  START GET FIELD OFFICER LOCATION DETAILS  *********/
export function* getFieldOfficerLocationDetails({ payload }: any) {
	try {
		const key = 'GetFieldOfficerLocationKey';
		const jsonData = {
			UserID: payload.userID,
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			InputDate: payload.inputDate,
		};
		const checkinLocationData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getFieldOfficerLocationAPI, checkinLocationData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getFieldOfficerLocationFailure(responseData.data));
		} else {
			yield put(getFieldOfficerLocationSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getFieldOfficerLocationFailure(error));
	}
}

export function* getFieldOfficerLocationDetailsResponseClear() {
	yield put(getFieldOfficerLocationResponseChanged());
}

export function* onGetFieldOfficerLocationGetStart() {
	yield takeLatest(
		OfficerLocationActionType.GET_FIELD_OFFICER_LOCATION_START,
		getFieldOfficerLocationDetails,
	);
}

export function* onGetFieldOfficerLocationGetResponseRest() {
	yield takeLatest(
		OfficerLocationActionType.GET_FIELD_OFFICER_LOCATION_RESPONSE_RESET,
		getFieldOfficerLocationDetailsResponseClear,
	);
}
/*********  END GET FIELD OFFICER LOCATION DETAILS  *********/

export function* fieldOfficerLocationSaga() {
	yield all([
		call(onGetFieldOfficerListStart),
		call(onGetFieldOfficerListResponseRest),
		call(onGetFieldOfficerLocationGetStart),
		call(onGetFieldOfficerLocationGetResponseRest),
	]);
}
